/* eslint-disable */
import { Grid, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_HERE_MAPS_COMPONENT_SELECT, UI_HERE_MAPS_COMPONENT_SELECT_ERROR } from '../../State/Store/UI/UI.types';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import PlaceOrderErrorMessage from '../PlaceOrder/PlaceOrderErrorMessage.component';
import HereMapsPropTypes from './HereMaps.component.props';
import HereMapsStyles from './HereMaps.component.styles';
import HereMapsAutocomplete from './HereMapsAutocomplete.component';

/**
 * HereMaps
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const HereMaps = ({ actions, classes, onLocationChange = () => {}, defaultLocation, services, disabled, hideMap, mandatoryFieldError, isDriverInstructionsRequired, onAddressStreetNumberChange }) => {
  const [coordinates, setCoordinates] = useState(defaultLocation ? defaultLocation.coords : null);
  const mapRef = useRef(null);
  const [hereMap, setHereMap] = useState(null);
  const [showError, setShowError] = useState(false);
  const [houseNumberMissing, setHouseNumberMissing] = useState(false);

  /**
   * Error handler to be used when we requesting user location
   * @param {Object} error The props
   * @returns {void} void
   */
  const errorHandler = (error) => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        console.log(`User denied the request for Geolocation`);
        break;
      case error.POSITION_UNAVAILABLE:
        console.log(`Location information is unavailable`);
        break;
      case error.TIMEOUT:
        console.log(`The request to get user location timed out`);
        break;
      case error.UNKNOWN_ERROR:
        console.log(`An unknown error occurred`);
        break;
      default:
        return null;
    }

    services.hereMapsService.renderMapWithDraggableMarker({ nodeRef: mapRef.current, H: window.H });
  };

  useEffect(() => {
    if (hideMap) {
      return;
    }

    const nodeRef = mapRef.current;

    // display initial map. We do not need user location at this point, if the requirements change, example code is below
    if (defaultLocation) {
      const map = services.hereMapsService.renderMapWithDraggableMarker({
        nodeRef,
        H: window.H,
        coords: {
          lat: defaultLocation.coords.lat,
          lng: defaultLocation.coords.lng,
        },
      });
      setHereMap(map);
      map.marker.setVisibility(true);
    } else if (services.hereMapsService) {
      setHereMap(
        services.hereMapsService.renderMapWithDraggableMarker({
          nodeRef,
          H: window.H,
        }),
      );
    }

    // enable this if need to ask user for his location
    // if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition((position) => {
    //     // get users location if allowed
    //     setHereMap(
    //       services.hereMapsService.renderMapWithDraggableMarker({
    //         nodeRef,
    //         H: window.H,
    //         coords: {
    //           lat: position.coords.latitude,
    //           lng: position.coords.longitude,
    //         },
    //       }),
    //     );
    //   }, errorHandler);
    // } else {
    //   console.log(`Geolocation is not supported by this browser.`);
    // }
  }, []);

  useEffect(() => {
    if (hereMap && coordinates) {
      hereMap.map.setCenter({
        lat: coordinates.lat,
        lng: coordinates.lng,
      });
      hereMap.marker.setGeometry({
        lat: coordinates.lat,
        lng: coordinates.lng,
      });
      hereMap.marker.setVisibility(true);
    }
  }, [coordinates]);

  /**
   * toggle handler, report currest state of switches to parent component
   * @param {string} name The props
   * @returns {void} void
   */
  const onSelectHandler = ({ coords, address: selectedAddress, details }) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `hereMapsComponentSelect`,
        },
      },
      type: UI_HERE_MAPS_COMPONENT_SELECT,
    });
    if (details.houseNumber) {
      onAddressStreetNumberChange(true);
    } else {
      onAddressStreetNumberChange(false);
    }
    onLocationChange({ selectedLocation: { address: selectedAddress, coords, details }, isValid: true });
    setCoordinates({ ...coords });
    return;
  };

  /**
   * Resets location and informs parent about error
   * @param {string} err Error message
   * @returns {void} void
   */
  const onErrorAutocompleteHandler = (err) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `hereMapsComponentSelectError`,
        },
      },
      type: UI_HERE_MAPS_COMPONENT_SELECT_ERROR,
    });
    onLocationChange({ selectedLocation: null, isValid: false });
    setShowError(true);
    return;
  };

  return (
    <Grid container spacing={disabled ? 0 : 2}>
      <Grid xs={12} item>
        <HereMapsAutocomplete
          mandatoryFieldError={
            mandatoryFieldError && (
              <span>
                The address entered is either invalid or not serviceable. Please try searching for the address again or{` `}
                <a
                  className={classes.callBoralLink}
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://www.boral.com.au/locations?product_category%5B86%5D=86"
                >
                  Call Boral
                </a>
                {` `}
                to place your order.
              </span>
            )
          }
          isDriverInstructionsRequired={isDriverInstructionsRequired}
          onError={onErrorAutocompleteHandler}
          onSelect={onSelectHandler}
          onClear={() => {
            setShowError(false);
            setHouseNumberMissing(false);
          }}
          disabled={disabled}
          defaultAddress={defaultLocation ? defaultLocation.address : null}
        />
      </Grid>
      <Grid xs={12} item>
        {!hideMap && <div className={classes.map} ref={mapRef} />}
      </Grid>
    </Grid>
  );
};

HereMaps.propTypes = HereMapsPropTypes;

export default compose(
  withServices,
  withStyles(themeCreateInjectableStyles(HereMapsStyles), { withTheme: true }),
  connect(null, (dispatch) => ({
    actions: bindActionCreators(
      {
        ...uiActionCreators,
      },
      dispatch,
    ),
  })),
)(HereMaps);
